import { TResourceValue, valuesManager } from '../../../../services/valuesManager/valuesManager';
import { defaultRxInformationState, RxInformationState } from '../prescriptionInformation/PrescriptionInformation';

export interface IDentalState extends RxInformationState {
    referralFor?: TResourceValue;
    referralForDescription?: string;
    visitPurpose?: TResourceValue;
    visitPurposeDescription?: string;
    howDidTheInjuryOccur?: string;
    dentistFirstName?: string;
    dentistLastName?: string;
    practiceName?: string;
    phone?: string;
    fax?: string;
    isOCwithProvider: boolean;
    previousTreatment?: string;
    isRush: boolean;
}

export const defaultDentalState: IDentalState = {
    referralFor: undefined,
    visitPurpose: valuesManager.resourceValues.dentalVisitPurposeValues[0],
    isOCwithProvider: false,
    isRush: false,
    errors: [],
    ...defaultRxInformationState,
};
